import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanDeactivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, first, map, tap } from 'rxjs/operators';
import { State } from '../State';
import { combineLatest, firstValueFrom, Observable } from 'rxjs';
import { LoginMeta, SettingsPageMeta, UserSettingsMeta } from '../../helper/page-metadata';
import { getUser } from '../State/selectors/users.selectors';
import { getPartner, getPartnerFetched } from '../State/selectors/partners.selectors';
import { isNotNullOrUndefined } from '../../helper/helper';
import { ToastrService } from 'ngx-toastr';
import { UserSettingsComponent } from '../../dave-settings-module/components/user-settings/user-settings.component';
import { getFetched$ } from '../helper/helper';
import { PartnerResolver } from './partner.resolver';
import { UserResolver } from './user.resolver';
import { ResolverLoadUser } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root',
})
export class MfaSettungsValidGuard implements CanActivate, CanDeactivate<UserSettingsComponent> {
    constructor(
        private store: Store<State>,
        private router: Router,
        private toastr: ToastrService,
        private partnerResolver: PartnerResolver,
    ) {}
    async settingsValid() {
        return await firstValueFrom(
            combineLatest([
                this.store.select(getUser),
                getFetched$(this.store, getPartnerFetched, getPartner, this.partnerResolver),
            ]).pipe(
                filter(values => values.every(value => isNotNullOrUndefined(value))),
                first(),
                map(([user, partner]) => {
                    return !!partner.MFAMethods.includes(user.MFAMethod);
                }),
            )
        );
    }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.settingsValid().then((valid) => {
            if (valid) {
                return true;
            }
            this.toastr.info('Bitte richten Sie die Zwei-Faktor-Authentifizierung ein');
            return this.router.createUrlTree(['/', SettingsPageMeta.Path, UserSettingsMeta.Path]);
            },
        );
    }
    async canDeactivate(component: UserSettingsComponent, currentRoute: ActivatedRouteSnapshot,  currentState: RouterStateSnapshot, nextState: RouterStateSnapshot): Promise<boolean> {
        console.log('currentRoute', {currentRoute, currentState, nextState});
        if (nextState.url.includes(LoginMeta.Path)) {
            return true;
        }
        const valid = await this.settingsValid();
        if (!valid) {
            this.toastr.warning('Bitte richten Sie zuerst die Zwei-Faktor-Authentifizierung ein');
        }
        return valid;
    }
}
